// extracted by mini-css-extract-plugin
export default {"scoreBlock":"ByUoj4irjt3bbtCkNPfz","contentWrapper":"p6i8lYzduvZQWSrjey3V","hidden":"L8HKZAI2WLtNXs7GrZwk"};